import { useState } from 'react';
import { Button, DataTable } from 'lift-ui';
import type { TableColumn } from 'lift-ui';
import { RefreshCw } from 'lucide-react';
import { useWorkers } from '../hooks';
import type { Worker } from '../types';
import { formatRelative, formatTimestamp } from '../utils';

const PAGE_SIZE = 25;

export const WorkersTab = () => {
  const [page, setPage] = useState(1);
  const { data, isLoading, isFetching, refetch } = useWorkers(page);

  const columns: TableColumn<Worker>[] = [
    { key: 'name', header: 'Worker', accessor: 'name' },
    {
      key: 'hostname',
      header: 'Host',
      accessor: 'hostname',
      render: (_value, row) => row.hostname ?? '—',
    },
    {
      key: 'last_heartbeat_at',
      header: 'Last heartbeat',
      accessor: 'last_heartbeat_at',
      render: (_value, row) => (
        <div className="flex flex-col">
          <span>{formatRelative(row.last_heartbeat_at)}</span>
          <span className="text-xs text-muted-foreground">
            {formatTimestamp(row.last_heartbeat_at)}
          </span>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-end">
        <Button variant="outline" size="sm" onClick={() => refetch()} disabled={isFetching}>
          <RefreshCw size={14} className={isFetching ? 'animate-spin' : ''} />
          Refresh
        </Button>
      </div>

      <DataTable<Worker>
        data={data?.data ?? []}
        columns={columns}
        showActions={false}
        loading={isLoading}
        emptyMessage="No workers are running"
        stickyHeader
        pagination={{
          currentPage: page,
          totalPages: data?.pagination.total_pages ?? 1,
          pageSize: PAGE_SIZE,
          totalItems: data?.pagination.total_count ?? data?.data.length ?? 0,
          onPageChange: setPage,
          onPageSizeChange: () => undefined,
          pageSizeOptions: [PAGE_SIZE],
        }}
      />
    </div>
  );
};

export default WorkersTab;
